import { SparkleIcon } from "@phosphor-icons/react";
import { useI18N } from "common/hooks";
import { cn } from "@/lib/utils";

/** Marks a group of tags as machine-written rather than recorded on site. */
export default function SmartTaggingPanel({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  const i18n = useI18N();

  return (
    <div
      className={cn(
        "flex flex-col gap-3 p-3 rounded-lg bg-bg-brand-tertiary-default border border-border-token-brand-minimal",
        className,
      )}
    >
      <div className="flex items-center gap-2">
        <SparkleIcon
          size={16}
          weight="fill"
          aria-hidden="true"
          className="text-fg-brand-subtle shrink-0"
        />
        <span className="label-m-semibold text-fg-brand-subtle">
          {i18n.get("smartTagging")}
        </span>
        <span className="rounded-full border border-border-token-brand-subtle bg-bg-brand-secondary-default px-2 py-0.5 label-s-medium text-fg-neutral-strong">
          {i18n.get("beta")}
        </span>
      </div>
      {children}
    </div>
  );
}
